/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Event_Text_Target_HelpInputs */

const en_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the group to copy text into`)
};

const fr_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez le groupe cible pour copier le texte`)
};

const de_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgruppe zum Kopieren des Textes auswählen`)
};

const it_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il gruppo in cui copiare il testo`)
};

const ru_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группу, в которую копировать текст`)
};

const es_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el grupo al que copiar el texto`)
};

const zh_cn2_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要复制文本的目标组`)
};

const ja_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストのコピー先グループを選択`)
};

const hi_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट कॉपी करने के लिए लक्ष्य समूह चुनें`)
};

const pt_pt2_copy_event_text_target_help = /** @type {(inputs: Copy_Event_Text_Target_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o grupo para onde copiar o texto`)
};

/**
* | output |
* | --- |
* | "Select the group to copy text into" |
*
* @param {Copy_Event_Text_Target_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_event_text_target_help = /** @type {((inputs?: Copy_Event_Text_Target_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Event_Text_Target_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_event_text_target_help(inputs)
	if (locale === "de") return de_copy_event_text_target_help(inputs)
	if (locale === "it") return it_copy_event_text_target_help(inputs)
	if (locale === "ru") return ru_copy_event_text_target_help(inputs)
	if (locale === "es") return es_copy_event_text_target_help(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_event_text_target_help(inputs)
	if (locale === "ja") return ja_copy_event_text_target_help(inputs)
	if (locale === "hi") return hi_copy_event_text_target_help(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_event_text_target_help(inputs)
	return en_copy_event_text_target_help(inputs)
});